export const BannerButtonSizeClassMap = {
  lg: 'md:text-base lg:text-lg lg:leading-6',
  md: 'lg:text-base lg:leading-4',
  sm: 'lg:text-sm lg:leading-3',
  xs: 'lg:text-sm lg:leading-2',
}
